<template>
    <gj-modal
            v-bind="$attrs"
            v-on="$listeners"
            :visible.sync="modalVisible"
            :size="'normal'"
            :confirmLoading="loading"
            @cancel="cancel"
            @confirm="confirm"
    >
        <template #header>重算</template>
        <template #content>
            <el-form :model="form" label-width="150px" ref="form">
                <el-form-item label="店铺" prop="marketIds" :rules="[
            {required: true, message: '请选择店铺', trigger: ['change', 'blur']}
        ]">
                    <gj-market-select
                            multiple
                            v-model="form.marketIds"
                            width="220px"
                            :clearable="false"
                    ></gj-market-select>
                </el-form-item>

                <el-form-item required label="重算时间区间" prop="date">
                    <gj-date-picker
                            type="daterange"
                            v-model="form.date"
                            width="220px"
                            :clearable="false"
                            :maxDayLength="maxDayLength"
                    ></gj-date-picker>
                </el-form-item>
            </el-form>
        </template>
    </gj-modal>
</template>

<script>
    import {modalMixIn} from "@/minxins";
    import {subDays} from "date-fns";
    import {recalculateFinanceProfitReport} from "@/api/finance";
    import {convertToDate} from "@/utils/date.util";
    import {isMeaningful} from "@/utils/common";

    export default {
        name: "finance-recalculate-modal",
        mixins: [modalMixIn],
        props: {
            maxDayLength: {
                type: Number,
                default: 180
            },
            days: {
                type: Number,
                default: 59
            },
            requestPromise: {
                type: Function,
                default: recalculateFinanceProfitReport
            },
            requestProps: {
                type: Object,
                validator (val) {
                    return ['startDate', 'endDate', 'marketIds'].every(v => Object.keys(val).includes(v))
                },
                default() {
                    return {
                        startDate: 'startDate',
                        endDate: 'endDate',
                        marketIds: 'marketIds'
                    }
                }
            }
        },
        data() {
            return {
                form: {
                    marketIds: [],
                    date: [],
                },
                loading: false,
            }
        },
        created () {
            this.form.date = [subDays(new Date(), this.days), new Date()]
        },
        methods: {
            confirm() {
                if (this.formValidate()) {
                    this.loading = true;
                    const props = this.requestProps
                    const params = {
                        [`${props.startDate}`]: convertToDate(this.form.date[0]),
                        [`${props.endDate}`]: convertToDate(this.form.date[1]),
                        [`${props.marketIds}`]: isMeaningful(this.form.marketIds) ? this.form.marketIds.map(v => Number(v)) : []

                    }
                    const promise = this.requestPromise.bind(null, params)
                    promise().then(() => {
                        this.$gjMessage.info('系统正在重算，请查看右上角任务进度');
                        this.$gjDestroy();
                    }).complete(() => this.loading = false)
                }
            },
            cancel() {
                this.$gjDestroy();
            },
            formValidate() {
                let formValid = false;
                this.$refs.form.validate((valid) => {
                    formValid = valid;
                });
                return formValid;
            },
        }
    }
</script>

<style scoped>

</style>
